module.exports = __webpack_public_path__ + "static/media/covid_19_banner.c0d6cf84.jpg";